import { render, staticRenderFns } from "./UiUrlLinker.vue?vue&type=template&id=0d009f29&scoped=true"
import script from "./UiUrlLinker.vue?vue&type=script&lang=js"
export * from "./UiUrlLinker.vue?vue&type=script&lang=js"
import style0 from "./UiUrlLinker.vue?vue&type=style&index=0&id=0d009f29&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d009f29",
  null
  
)

export default component.exports